module.exports = __webpack_public_path__ + "img/xrp_vs_xlm_pt2.2f24621b.png";